import lodash from 'lodash';
import * as types from '../constants';

const INITIAL_STATE = {
   candidates: [],
   selectedIds: [],
   forwardModal: {
      isOpen: false,
      ids: [],
      candidates: [],
   },
   resumeModal: {
      isOpen: false,
      candidate: {},
      isCursorOnCandidate: false,
      isCursorOnModal: false,
   },
   elementRect: {},
};

const getInitialState = () => (lodash.cloneDeep(INITIAL_STATE));

export default function candidatesReducer(state = INITIAL_STATE, action) {
   switch (action.type) {
      case types.CANDIDATE_INITIALIZE:
         return getInitialState();
      case types.CANDIDATE_DESTROY:
         return {};
      case types.CANDIDATE_SET_CANDIDATES:
         return {
            ...state,
            candidates: action.candidates,
         };
      case types.CANDIDATE_SET_CANDIDATE_RATING:

         const newCandidates = state.candidates.map((candidate) => {
            if (+candidate.candidateId === +action.id) {
               return ({
                  ...candidate,
                  rating: action.rating,
               });
            } else {
               return candidate;
            }
         });

         return {
            ...state,
            candidates: newCandidates,
         };
      case types.CANDIDATE_HIDE_CANDIDATE:
         return {
            ...state,
            candidates: state.candidates.filter(({ candidateId }) => +candidateId !== +action.id),
            selectedIds: state.selectedIds.filter((candidateId) => +candidateId !== +action.id),
         };
      //  selectedIds
      case types.CANDIDATE_TOGGLE_SELECTED_IDS_ALL:
         if (state.selectedIds.length === state.candidates.length) {
            return {
               ...state,
               selectedIds: [],
            };
         } else {
            return {
               ...state,
               selectedIds: state.candidates.map(({ candidateId }) => candidateId),
            };
         }
      case types.CANDIDATE_INSERT_SELECTED_IDS:
         return {
            ...state,
            selectedIds: [...state.selectedIds, action.id],
         };
      case types.CANDIDATE_REMOVE_SELECTED_IDS:
         return {
            ...state,
            selectedIds: state.selectedIds.filter((id) => id !== action.id),
         };
      case types.CANDIDATE_TOGGLE_SELECTED_ID:
         if (state.selectedIds.indexOf(action.id) !== -1) {
            return {
               ...state,
               selectedIds: state.selectedIds.filter((id) => id !== action.id),
            };
         } else {
            return {
               ...state,
               selectedIds: [...state.selectedIds, action.id],
            };
         }
      case types.CANDIDATE_CLEAR_SELECTED_IDS:
         return {
            ...state,
            selectedIds: [],
         };
      case types.CANDIDATE_INSERT_ALL_SELECTED_IDS:
         return {
            ...state,
            selectedIds: state.candidates.map(({ candidateId }) => candidateId),
         };
      //  selectedIds + candidate
      case types.CANDIDATE_HIDE_CANDIDATES:
         /*
               Removes the selected "candidates" in the candidates list and clears the selectedIds
          */
         const updatedCandidates = state.candidates.filter(
            ({ candidateId }) => !(state.selectedIds.includes(+candidateId)),
         );

         return {
            ...state,
            candidates: updatedCandidates,
            selectedIds: [],
         };
      case types.CANDIDATE_SET_CANDIDATES_RATING:
         return {
            ...state,
            candidates: state.candidates.map((candidate) => {
               if (state.selectedIds.indexOf(candidate.candidateId) !== -1) {
                  return {
                     ...candidate,
                     rating: action.rating,
                  };
               } else {
                  return candidate;
               }
            }),
         };
      //  MODAL: Forward
      case types.CANDIDATE_OPEN_FORWARD_MODAL:
         let candidates = [];

         if (action.ids && action.ids.length > 0) {
            for (const candidate of state.candidates) {
               const { candidateId, fname, lname } = candidate;

               if (action.ids.indexOf(candidateId) !== -1) {
                  candidates.push({
                     fname,
                     lname,
                     id: candidateId,
                  });
               }
            }
         }

         return {
            ...state,
            forwardModal: {
               ...state.forwardModal,
               isOpen: true,
               ids: action.ids,
               candidates,
            },
         };
      case types.CANDIDATE_CLOSE_FORWARD_MODAL:
         return {
            ...state,
            forwardModal: {
               ...state.forwardModal,
               isOpen: false,
               ids: [],
               candidates: [],
            },
         };
      // MODAL: Resume
      case types.CANDIDATE_OPEN_RESUME_MODAL:

         let selectedCandidate = state.candidates.find(({ candidateId }) => +candidateId === +action.id);

         if (selectedCandidate) {
            selectedCandidate = lodash.cloneDeep(selectedCandidate);
         } else {
            selectedCandidate = {};
         }

         return {
            ...state,
            resumeModal: {
               ...state.resumeModal,
               isOpen: true,
               candidate: selectedCandidate,
               isCursorOnCandidate: true,
               isCursorOnModal: false,
            },
         };
      case types.CANDIDATE_CLOSE_RESUME_MODAL:
         return ({
            ...state,
            resumeModal: {
               ...state.resumeModal,
               isOpen: false,
               candidate: {},
               isCursorOnCandidate: false,
               isCursorOnModal: false,
            },
         });
      case types.CANDIDATE_SET_CURSOR_ON_CANDIDATE:
         // check if action.candidateId matches -- if not set flag onCandidateFalse
         const isCursorOnCurrentCandidate = state.resumeModal
            && state.resumeModal.isOpen
            && state.resumeModal.candidate
            && state.resumeModal.candidate.candidateId
            && action.candidateId === state.resumeModal.candidate.candidateId;
         return ({
            ...state,
            resumeModal: {
               ...state.resumeModal,
               isCursorOnCandidate: isCursorOnCurrentCandidate,
            },
         });
      case types.CANDIDATE_SET_CURSOR_ON_MODAL:
         return ({
            ...state,
            resumeModal: {
               ...state.resumeModal,
               isCursorOnModal: true,
            },
         });
      case types.CANDIDATE_SET_CURSOR_LEFT_CANDIDATE:
         return ({
            ...state,
            resumeModal: {
               ...state.resumeModal,
               isCursorOnCandidate: false,
            },
         });
      case types.CANDIDATE_SET_CURSOR_LEFT_MODAL:
         return ({
            ...state,
            resumeModal: {
               ...state.resumeModal,
               isCursorOnModal: false,
            },
         });
      case types.CANDIDATE_SET_ELEMENT_RECT:
         return ({
            ...state,
            elementRect: action.payload,
         });
      default:
         return state;
   }
}
